// eslint-disable-next-line import/prefer-default-export,no-restricted-syntax
export enum BannerType {
  GoodBetterBest = "GoodBetterBest",
  SideBySide = "SideBySide",
}
